import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { useBankingDetails } from '../../hooks/useBanking';
import { BANKING_CARDS } from '../../constants/auth';
import BankingPageCardsSkeleton from '../../viewsv2/Banking/Cards/skeleton';

type BankingCardsGuardProps = {
  children: React.ReactNode;
};

const BankingCardsGuard = ({ children }: BankingCardsGuardProps) => {
  const companyUser = useAppSelector((state) => state.companyUser);
  const selectedCompany = companyUser.companyUser?.selectedCompany;

  const { data: bankingInfo, isFetching: isFetchingBankingInfo } = useBankingDetails({
    companyId: selectedCompany?.id,
  });

  // Show loading while fetching banking info
  if (isFetchingBankingInfo || !selectedCompany) {
    return <BankingPageCardsSkeleton />;
  }

  // Block access if company is from Mexico
  if (bankingInfo?.country === 'mexico') {
    return <Navigate to={BANKING_CARDS} replace />;
  }

  return <>{children}</>;
};

export default BankingCardsGuard;
